import {StyleSheet} from 'aphrodite/no-important';

/* https://www.w3schools.com/howto/howto_css_modals.asp */
export const styles = StyleSheet.create({
        modal: {
            position: 'fixed',
            zIndex: 1000001,
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            overflow: 'auto',
            backgroundColor: '#555',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },

        modalContent: {
            disable: 'none',
            position: 'relative',
            backgroundColor: '#fefefe',
            margin: '10% auto',
            padding: '20px',
            border: '1px solid #888',
            width: '80%',
            maxWidth: '1000px',
            animation: 'fadein 2s',
        },

        close: {
            position: 'absolute',
            top: '10px',
            right: '10px',
            color: '#aaa',
            fontSize: '40px',
            cursor: 'pointer',
        }
    })
;



// WEBPACK FOOTER //
// ./react-app-src/shared/styles/FsModalStyles.js